<template>
  <div class="emat-order-summary-holder">
    <div class="pre-list" v-if="!order">
      <slot name="pre-list"></slot>
    </div>
    <div class="emat-order-summary" :class="{'order': order}">
      <div class="list" :class="{'order': order}">
        <div style="display: flex; justify-content: space-between; align-items: center; padding-bottom: 10px;">
          <span class="name" v-text="name"></span>
          <span class="warranty" v-if="device === 'mobile'">{{ $t('OrderMenu.warranty') }}</span>
        </div>
        <div class="options">
          <div class="option" v-for="(option, key) in options" :key="key">
            <span class="label" v-text="key"></span>
            <span class="sub-label" v-text="option"></span>
          </div>
        </div>
        <div class="extras" v-if="!hasProducts(products)">
          <span class="title">Installatiebenodigdheden</span>
          <div class="extra" v-for="(option, key) in products" :key="key">
            <span class="label" v-text="key" v-if="!hasProducts(option)"></span>
            <div class="product" v-for="product in option">
              <span class="amount" v-text="product.amount"></span>
              <span class="sub-label" v-text="product.name"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="footer" v-if="footer">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmatOrderSummary',
  props: {
    /**
     * Unique name for your layout
     */
    name: {
      type: String,
      required: true,
    },
    /**
     * Options defined as label and sub-label (label is blue, sublabel is black)
     */
    options: {
      type: Object,
      required: true,
      default: null,
    },
    /**
     * Options defined as label and sub-label (label is blue, sublabel is black)
     */
    products: {
      type: Object,
      required: false,
      default: null,
    },
    /**
     * Footer block for order summary (Boolean)
     */
    footer: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Specify if it's the order menu (Boolean)
     */
    order: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Menu type, Laadpaal: 1, Laadzuil: 2
     */
    type: {
      type: Object,
      required: false,
    },

    device: {
      type: String,
      default: null,
    },
  },

  methods: {
    hasProducts(products) {
      return Object.keys(products).every(function(key) {
        return products[key].length === 0;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/sass/abstracts";

.emat-order-summary-holder {
  .pre-list {
    margin: 10px 0;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;

    > span {
      display: block;
      font-family: var(--font);
      font-weight: $font-weight-bold;
      font-size: 12px;
      margin-left: 10px;
      text-align: center;
    }
  }

  .emat-order-summary {
    margin-top: 10px;
    font-family: var(--font);
    box-shadow: 0 0 10px rgba(0, 0, 0, .2);
    font-size: 12px;
    font-weight: 600;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    position: relative;
    border-radius: $border-radius;

    &.mobile {
      max-width: 100%;
    }

    &.order {
      background-color: unset;
      box-shadow: unset;
      margin: 0;
      font-family: var(--font);
      font-weight: 900;
    }

    .list {
      padding: 10px;

      &.order {
        padding: 0;
        margin-bottom: 10px;
      }

      .name {
        @include header-font;
        display: block;
        font-size: 18px;
        color: var(--c-title);
      }

      .warranty {
        font-size: 14px;
        font-family: var(--font-black);
      }

      .options {
        @media only screen and (max-width: 420px) {
          max-height: 100px;
          display: flex;
          flex-direction: column;
          flex-wrap: wrap;
        }
      }

      .options, .extras {
        .title {
          @include header-font;
          font-size: 16px;
          margin: 5px 0;
          display: block;
          color: var(--c-title);
        }

        .option, .extra {
          margin: 0;
          font-size: 12px;
          font-weight: 400;
          display: flex;
          flex-direction: column;
          line-height: 1.1;
          padding-bottom: 2px;

          .label {
            color: var(--c-primary);
            font-size: 12px;
            font-weight: $font-weight-bold;
          }

          .sub-label {
            color: #000;
            font-weight: $font-weight-thin;
          }
        }

        .product {
          line-height: 16px;
          color: rgba(0, 0, 0, .5);
          display: flex;

          .amount {
            @include header-font;
            border-right: 1px solid #e9e9e9;
            margin-right: 5px;
            color: var(--c-primary);
            font-size: 12px;
            width: 15px;
            min-width: 15px;
            text-align: center;
            display: block;
          }

          .sub-label {
            padding-left: 5px;
          }
        }
      }
    }

    .footer {
      background-color: var(--c-primary-lightest);
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 8px 10px;
      border-bottom-left-radius: $border-radius;
      border-bottom-right-radius: $border-radius;

      @media only screen and (max-width: 576px) {
        margin-left: -20px;
        margin-right: -20px;
        padding: 8px 18px;
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
      }

      .text {
        display: block;
        margin-left: 6px;
        font-weight: $font-weight-thin;
      }

      strong {
        font-family: var(--font-black);
      }
    }
  }
}
</style>
